
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 6C117.933 6 6 117.933 6 256c0 138.066 111.933 250 250 250s250-111.934 250-250C506 117.933 394.067 6 256 6zm0 470.5c-121.782 0-220.5-98.719-220.5-220.5 0-121.782 98.719-220.5 220.5-220.5 121.78 0 220.5 98.719 220.5 220.5S377.78 476.5 256 476.5z"}}),_c('path',{attrs:{"d":"M338.677 304.646c-3.732-3.361-9.484-3.082-12.884.611l-29.807 29.793-4.609-2.724c-2.645-1.581-5.513-3.199-8.727-4.952a222.559 222.559 0 01-97.708-97.761 403.017 403.017 0 00-4.901-8.606l-2.723-4.611 29.821-29.82a9.177 9.177 0 00.61-12.884l-44.165-44.165c-3.731-3.359-9.485-3.082-12.885.611l-7.705 7.771a54.98 54.98 0 00-11.542 18.396 61.678 61.678 0 00-3.759 14.956c-4.449 36.899 6.136 74.967 72.217 141.128 77.796 77.784 140.637 72.35 141.248 72.35a63.338 63.338 0 0014.969-3.771 55.032 55.032 0 0018.33-11.529l2.192-2.139 5.564-5.563c3.706-3.415 3.985-9.193.625-12.951l-44.161-44.14z"}})])
          )
        }
      }
    